<script setup lang="ts">
import { useCragModel, useBoulderModel, useLineModel } from '../composables/app';
import CragView from './crag_view.vue';
import LineView from './line_view.vue';
import BoulderView from './boulder_view.vue';
import { computed, nextTick, ref, watch } from 'vue';
import type { WatchSource } from 'vue';
import { getApplicationInstance } from '../../../core/app.ts';

const cragModel = useCragModel();
const sidebarOpen = computed(() => {
    return cragModel.value !== null;
});
const boulderModel = useBoulderModel();
const lineModel = useLineModel();

const boulderContainer = ref<HTMLElement | null>(null);
const lineContainer = ref<HTMLElement | null>(null);

function revealOnAppear(source: WatchSource<unknown>, target: () => HTMLElement | null) {
    watch(source, async (value) => {
        if (!value) return;
        await nextTick();
        const el = target();
        if (!el) return;
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
}

revealOnAppear(boulderModel, () => boulderContainer.value);
revealOnAppear(lineModel, () => lineContainer.value);

const app = getApplicationInstance();
</script>

<template>
    <div class="sidebar" :class="{ 'open': sidebarOpen }" :style="{ '--max-grade': app.maxGrade.index }">
        <CragView :crag="cragModel"></CragView>
        <div v-if="boulderModel" ref="boulderContainer">
            <BoulderView :boulder="boulderModel"></BoulderView>
        </div>
        <div v-if="lineModel" ref="lineContainer">
            <LineView :line="lineModel"></LineView>
        </div>
    </div>
    <div id="map"></div>
</template>
